(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!window.customElements.get('yg-article-toc')) {
    class YGArticleToc extends HTMLElement {
      connectedCallback() {
        this.$section = this.closest('[id^="shopify-section-"]') || this.closest('.shopify-section');
        this.$prose = this.$section?.querySelector('.prose');
        this.$list = this.querySelector('[data-article-toc-list]');
        this.$details = this.querySelector('details');
        this.scrollAbortController?.abort();
        this.scrollAbortController = new AbortController();

        this.buildToc();
        window.addEventListener('scroll', this.handlePageScroll.bind(this), {
          passive: true,
          signal: this.scrollAbortController.signal
        });
      }

      disconnectedCallback() {
        this.scrollAbortController?.abort();
      }

      handlePageScroll() {
        if (this.$details?.open) {
          this.$details.open = false;
        }
      }

      buildToc() {
        if (!this.$prose || !this.$list) {
          return;
        }

        const headings = Array.from(this.$prose.querySelectorAll('h2')).filter((heading) => heading.textContent.trim() !== '');

        if (headings.length === 0) {
          this.hidden = true;
          return;
        }

        this.$list.replaceChildren();

        headings.forEach((heading, index) => {
          if (!heading.id) {
            heading.id = this.createHeadingId(heading, index);
          }

          const $link = document.createElement('a');
          $link.className = 'yg-article-toc__link';
          $link.href = `#${heading.id}`;
          $link.textContent = heading.textContent.trim();
          $link.addEventListener('click', () => {
            this.$details?.removeAttribute('open');
          });

          this.$list.append($link);
        });

        this.hidden = false;
      }

      createHeadingId(heading, index) {
        const baseId = heading.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9\u4e00-\u9fa5]+/g, '-')
          .replace(/^-+|-+$/g, '');
        const fallbackId = `article-heading-${index + 1}`;
        let headingId = baseId || fallbackId;
        let duplicateIndex = 2;

        while (document.getElementById(headingId)) {
          headingId = `${baseId || fallbackId}-${duplicateIndex}`;
          duplicateIndex += 1;
        }

        return headingId;
      }
    }

    window.customElements.define('yg-article-toc', YGArticleToc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-brand-commitment"] && !Shopify.designMode) return;
  try {
    
  class YGBrandCommitment extends HTMLElement {
    constructor() {
      super();
      this.handlePreviousClick = this.handlePreviousClick.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback() {
      this.$list = this.querySelector('[data-yg-brand-commitment-list]');
      this.$previousButton = this.querySelector('[data-yg-brand-commitment-previous]');
      this.$nextButton = this.querySelector('[data-yg-brand-commitment-next]');

      if (!this.$list || !this.$previousButton || !this.$nextButton) {
        return;
      }

      this.$previousButton.addEventListener('click', this.handlePreviousClick);
      this.$nextButton.addEventListener('click', this.handleNextClick);
      this.$list.addEventListener('scroll', this.handleScroll, { passive: true });
      this.updateButtons();
    }

    disconnectedCallback() {
      if (!this.$list || !this.$previousButton || !this.$nextButton) {
        return;
      }

      this.$previousButton.removeEventListener('click', this.handlePreviousClick);
      this.$nextButton.removeEventListener('click', this.handleNextClick);
      this.$list.removeEventListener('scroll', this.handleScroll);
    }

    handlePreviousClick() {
      this.scrollByCard(-1);
    }

    handleNextClick() {
      this.scrollByCard(1);
    }

    handleScroll() {
      window.requestAnimationFrame(() => this.updateButtons());
    }

    scrollByCard(direction) {
      const firstCard = this.$list.querySelector('.yg-brand-commitment__item');

      if (!firstCard) {
        return;
      }

      const style = window.getComputedStyle(this.$list);
      const gap = parseFloat(style.columnGap || style.gap) || 0;
      const distance = firstCard.getBoundingClientRect().width + gap;

      this.$list.scrollBy({
        left: distance * direction,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      const maxScrollLeft = this.$list.scrollWidth - this.$list.clientWidth;

      this.$previousButton.disabled = this.$list.scrollLeft <= 1;
      this.$nextButton.disabled = this.$list.scrollLeft >= maxScrollLeft - 1;
    }
  }

  if (!window.customElements.get('yg-brand-commitment')) {
    window.customElements.define('yg-brand-commitment', YGBrandCommitment);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-category-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGCategorySwiperSection extends HTMLElement {
    constructor() {
      super();
      this.mobileQuery = window.matchMedia('(max-width: 699px)');
      this.boundSwipers = new Set();
      this.syncFrame = null;
      this.syncAttemptCount = 0;
      this.syncRetryTimer = null;
      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.syncCurrentSwiper = this.syncCurrentSwiper.bind(this);
      this.syncCurrentNavigation = this.syncCurrentNavigation.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.mobileQuery.addEventListener('change', this.handleViewportChange);
      window.addEventListener('resize', this.handleViewportChange, { passive: true });
      this.handleViewportChange();
    }

    disconnectedCallback() {
      this.mobileQuery.removeEventListener('change', this.handleViewportChange);
      window.removeEventListener('resize', this.handleViewportChange);
      window.cancelAnimationFrame(this.syncFrame);
      this.boundSwipers.forEach((swiper) => {
        swiper.off('slideChange transitionEnd resize breakpoint update lock unlock', this.syncCurrentNavigation);
      });
      this.boundSwipers.clear();
      this.isInitialized = false;
      this.syncAttemptCount = 0;
      window.clearTimeout(this.syncRetryTimer);
    }

    handleViewportChange() {
      window.cancelAnimationFrame(this.syncFrame);
      this.syncFrame = window.requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.bindSwiperEvents();
        this.syncCurrentSwiper();
      });
    }

    syncCurrentNavigation() {
      const swiperElement = this.getCurrentSwiperElement();
      const swiper = swiperElement?.swiper;

      if (swiper && !swiper.destroyed) this.syncNavigationState(swiperElement, swiper);
    }

    bindSwiperEvents() {
      this.querySelectorAll('yg-swiper').forEach((swiperElement) => {
        const swiper = swiperElement.swiper;

        if (!swiper || this.boundSwipers.has(swiper)) return;

        this.boundSwipers.add(swiper);
        swiper.on('slideChange transitionEnd resize breakpoint update lock unlock', this.syncCurrentNavigation);
      });
    }

    getCurrentSwiperElement() {
      const selector = this.mobileQuery.matches ? '.yg-category-swiper-mobile' : '.yg-category-swiper-desktop';

      return this.querySelector(selector);
    }

    syncCurrentSwiper() {
      const swiperElement = this.getCurrentSwiperElement();
      const swiper = swiperElement?.swiper;

      if (!swiper || swiper.destroyed) {
        this.retrySync();
        return;
      }

      this.syncAttemptCount = 0;

      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      swiper.pagination?.update();
      this.syncNavigationState(swiperElement, swiper);
    }

    retrySync() {
      if (this.syncAttemptCount >= 20) return;

      this.syncAttemptCount += 1;
      window.clearTimeout(this.syncRetryTimer);
      this.syncRetryTimer = window.setTimeout(this.handleViewportChange, 50);
    }

    syncNavigationState(swiperElement, swiper) {
      const previousButton = swiperElement.querySelector('.swiper-button-prev');
      const nextButton = swiperElement.querySelector('.swiper-button-next');
      const isLocked = swiper.isLocked || swiper.snapGrid.length <= 1;

      this.setButtonState(previousButton, swiper.isBeginning || isLocked, isLocked);
      this.setButtonState(nextButton, swiper.isEnd || isLocked, isLocked);
    }

    setButtonState(button, isDisabled, isLocked) {
      if (!button) return;

      button.classList.toggle('swiper-button-disabled', isDisabled);
      button.classList.toggle('swiper-button-lock', isLocked);
      button.setAttribute('aria-disabled', String(isDisabled));
    }
  }

  if (!window.customElements.get('yg-category-swiper-section')) {
    window.customElements.define('yg-category-swiper-section', YGCategorySwiperSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-faq"] && !Shopify.designMode) return;
  try {
    
  class YGFAQTabs extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-yg-faq-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-yg-faq-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
      });
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
      });
    }

    handleTabClick(event) {
      const selectedTab = event.currentTarget;
      const selectedPanelId = selectedTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', tab === selectedTab ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== selectedPanelId;
      });
    }
  }

  if (!window.customElements.get('yg-faq-tabs')) {
    window.customElements.define('yg-faq-tabs', YGFAQTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGImageTabs extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.$tabList = this.querySelector('yg-tabs-title');
      this.$swiper = this.querySelector('yg-swiper');
      this.$tabs = Array.from(this.querySelectorAll('[data-yg-image-tab-index]'));
      this.$panels = Array.from(this.querySelectorAll('[data-yg-image-tab-panel]'));

      if (!this.$tabList || !this.$swiper || this.$tabs.length === 0) return;

      this.$tabList.setAttribute('role', 'tablist');
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleSlideChange = this.handleSlideChange.bind(this);
      this.$tabList.addEventListener('click', this.handleTabClick);
      this.isInitialized = true;
      this.bindSwiper();
    }

    disconnectedCallback() {
      this.$tabList?.removeEventListener('click', this.handleTabClick);
      this.swiper?.off('slideChange', this.handleSlideChange);
      window.cancelAnimationFrame(this.bindFrame);
      this.isInitialized = false;
    }

    bindSwiper() {
      if (!this.isConnected) return;

      if (!this.$swiper.swiper) {
        this.bindFrame = window.requestAnimationFrame(() => this.bindSwiper());
        return;
      }

      this.swiper = this.$swiper.swiper;
      this.swiper.on('slideChange', this.handleSlideChange);
      this.setActiveTab(this.swiper.activeIndex);
    }

    handleTabClick(event) {
      const $tab = event.target.closest('[data-yg-image-tab-index]');
      if (!$tab || !this.swiper) return;

      this.swiper.slideTo(Number($tab.dataset.ygImageTabIndex));
    }

    handleSlideChange() {
      this.setActiveTab(this.swiper.activeIndex);
    }

    setActiveTab(index) {
      const $activeTab = this.$tabs[index];
      if (!$activeTab) return;

      this.$tabs.forEach(($tab, tabIndex) => {
        const isActive = tabIndex === index;
        $tab.classList.toggle('is-active', isActive);
        $tab.setAttribute('aria-selected', String(isActive));
        $tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.$panels.forEach(($panel, panelIndex) => {
        $panel.setAttribute('aria-hidden', String(panelIndex !== index));
      });

      this.$tabList.updateStyle?.($activeTab);
      this.$tabList.scrollItemIntoView?.($activeTab);
    }
  }

  if (!window.customElements.get('yg-image-tabs')) {
    window.customElements.define('yg-image-tabs', YGImageTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-group-01"] && !Shopify.designMode) return;
  try {
    
  class YGMediaGroup01 extends HTMLElement {
    constructor() {
      super();
      this.mobileQuery = window.matchMedia('(max-width: 699px)');
      this.boundSwipers = new Set();
      this.syncFrame = null;
      this.syncAttemptCount = 0;
      this.syncRetryTimer = null;
      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.syncCurrentSwiper = this.syncCurrentSwiper.bind(this);
      this.syncCurrentNavigation = this.syncCurrentNavigation.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.mobileQuery.addEventListener('change', this.handleViewportChange);
      window.addEventListener('resize', this.handleViewportChange, { passive: true });
      this.handleViewportChange();
    }

    disconnectedCallback() {
      this.mobileQuery.removeEventListener('change', this.handleViewportChange);
      window.removeEventListener('resize', this.handleViewportChange);
      window.cancelAnimationFrame(this.syncFrame);
      this.boundSwipers.forEach((swiper) => {
        swiper.off('slideChange transitionEnd resize breakpoint update lock unlock', this.syncCurrentNavigation);
      });
      this.boundSwipers.clear();
      this.isInitialized = false;
      this.syncAttemptCount = 0;
      window.clearTimeout(this.syncRetryTimer);
    }

    handleViewportChange() {
      window.cancelAnimationFrame(this.syncFrame);
      this.syncFrame = window.requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.bindSwiperEvents();
        this.syncCurrentSwiper();
      });
    }

    syncCurrentNavigation() {
      const swiperElement = this.getCurrentSwiperElement();
      const swiper = swiperElement?.swiper;

      if (swiper && !swiper.destroyed) this.syncNavigationState(swiperElement, swiper);
    }

    bindSwiperEvents() {
      this.querySelectorAll('yg-swiper').forEach((swiperElement) => {
        const swiper = swiperElement.swiper;

        if (!swiper || this.boundSwipers.has(swiper)) return;

        this.boundSwipers.add(swiper);
        swiper.on('slideChange transitionEnd resize breakpoint update lock unlock', this.syncCurrentNavigation);
      });
    }

    getCurrentSwiperElement() {
      const selector = this.mobileQuery.matches ? '.yg-media-group-swiper-mobile' : '.yg-media-group-swiper-desktop';

      return this.querySelector(selector);
    }

    syncCurrentSwiper() {
      const swiperElement = this.getCurrentSwiperElement();
      const swiper = swiperElement?.swiper;

      if (!swiper || swiper.destroyed) {
        this.retrySync();
        return;
      }

      this.syncAttemptCount = 0;

      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      swiper.pagination?.update();
      this.syncNavigationState(swiperElement, swiper);
    }

    retrySync() {
      if (this.syncAttemptCount >= 20) return;

      this.syncAttemptCount += 1;
      window.clearTimeout(this.syncRetryTimer);
      this.syncRetryTimer = window.setTimeout(this.handleViewportChange, 50);
    }

    syncNavigationState(swiperElement, swiper) {
      const previousButton = swiperElement.querySelector('.swiper-button-prev');
      const nextButton = swiperElement.querySelector('.swiper-button-next');
      const isLocked = swiper.isLocked || swiper.snapGrid.length <= 1;

      this.setButtonState(previousButton, swiper.isBeginning || isLocked, isLocked);
      this.setButtonState(nextButton, swiper.isEnd || isLocked, isLocked);
    }

    setButtonState(button, isDisabled, isLocked) {
      if (!button) return;

      button.classList.toggle('swiper-button-disabled', isDisabled);
      button.classList.toggle('swiper-button-lock', isLocked);
      button.setAttribute('aria-disabled', String(isDisabled));
    }
  }

  if (!window.customElements.get('yg-media-group-01')) {
    window.customElements.define('yg-media-group-01', YGMediaGroup01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
        this.mobileMediaQuery = window.matchMedia('(max-width: 699px)');
        this.handleMobileMediaChange = this.handleMobileMediaChange.bind(this);
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
        this.setMobileInitialSlide();
        if (typeof this.mobileMediaQuery.addEventListener === 'function') {
          this.mobileMediaQuery.addEventListener('change', this.handleMobileMediaChange);
        } else {
          this.mobileMediaQuery.addListener(this.handleMobileMediaChange);
        }
      }

      disconnectedCallback() {
        if (typeof this.mobileMediaQuery.removeEventListener === 'function') {
          this.mobileMediaQuery.removeEventListener('change', this.handleMobileMediaChange);
        } else {
          this.mobileMediaQuery.removeListener(this.handleMobileMediaChange);
        }
      }

      handleMobileMediaChange(event) {
        if (!event.matches) return;

        this.setMobileInitialSlide();
      }

      setMobileInitialSlide() {
        const slideCount = this.querySelectorAll('.swiper-slide').length;

        if (!this.mobileMediaQuery.matches || slideCount < 2 || !this.swiper) return;

        if (typeof this.swiper.slideToLoop === 'function') {
          this.swiper.slideToLoop(1, 0, false);
          return;
        }

        if (typeof this.swiper.slideTo === 'function') {
          this.swiper.slideTo(1, 0, false);
        }
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }

    const mobileMarqueeQuery = window.matchMedia('(max-width: 699px)');

    document.querySelectorAll('.yg-multi-column-marquee-row').forEach((row) => {
      if (row.dataset.mobileDragBound === 'true') return;

      row.dataset.mobileDragBound = 'true';
      row.classList.add('is-mobile-draggable');

      const track = row.querySelector('.yg-multi-column-marquee-track');
      let activePointerId = null;
      let startX = 0;
      let startOffset = 0;
      let currentOffset = 0;
      let hasDragged = false;

      const finishDrag = (event) => {
        if (activePointerId !== event.pointerId) return;

        row.classList.remove('is-mobile-dragging');
        if (row.hasPointerCapture(event.pointerId)) {
          row.releasePointerCapture(event.pointerId);
        }
        activePointerId = null;
      };

      row.addEventListener('pointerdown', (event) => {
        if (!mobileMarqueeQuery.matches || !track || event.pointerType === 'mouse') return;

        activePointerId = event.pointerId;
        startX = event.clientX;
        startOffset = currentOffset;
        hasDragged = false;
        row.classList.add('is-mobile-dragging');
        row.setPointerCapture(event.pointerId);
      });

      row.addEventListener('pointermove', (event) => {
        if (activePointerId !== event.pointerId) return;

        const distance = event.clientX - startX;
        if (Math.abs(distance) > 5) {
          hasDragged = true;
        }

        currentOffset = startOffset + distance;
        row.style.setProperty('--multi-column-marquee-drag-offset', `${currentOffset}px`);
      });

      row.addEventListener('pointerup', finishDrag);
      row.addEventListener('pointercancel', finishDrag);
      row.addEventListener('click', (event) => {
        if (!hasDragged) return;

        event.preventDefault();
        event.stopPropagation();
        hasDragged = false;
      }, true);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-photo-wall"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGPhotoWallCarousel extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }

    if (!customElements.get('yg-photo-wall-carousel')) {
      customElements.define('yg-photo-wall-carousel', YGPhotoWallCarousel);
    }

    const mobileMarqueeQuery = window.matchMedia('(max-width: 699px)');

    document.querySelectorAll('.yg-photo-wall-marquee').forEach((marquee) => {
      if (marquee.dataset.mobileDragBound === 'true') return;

      marquee.dataset.mobileDragBound = 'true';
      marquee.classList.add('is-mobile-draggable');

      const track = marquee.querySelector('.yg-photo-wall-marquee-track');
      let activePointerId = null;
      let startX = 0;
      let startOffset = 0;
      let currentOffset = 0;
      let hasDragged = false;

      const finishDrag = (event) => {
        if (activePointerId !== event.pointerId) return;

        marquee.classList.remove('is-mobile-dragging');
        if (marquee.hasPointerCapture(event.pointerId)) {
          marquee.releasePointerCapture(event.pointerId);
        }
        activePointerId = null;
      };

      marquee.addEventListener('pointerdown', (event) => {
        if (!mobileMarqueeQuery.matches || !track || event.pointerType === 'mouse') return;

        activePointerId = event.pointerId;
        startX = event.clientX;
        startOffset = currentOffset;
        hasDragged = false;
        marquee.classList.add('is-mobile-dragging');
        marquee.setPointerCapture(event.pointerId);
      });

      marquee.addEventListener('pointermove', (event) => {
        if (activePointerId !== event.pointerId) return;

        const distance = event.clientX - startX;
        if (Math.abs(distance) > 5) {
          hasDragged = true;
        }

        currentOffset = startOffset + distance;
        marquee.style.setProperty('--photo-wall-marquee-drag-offset', `${currentOffset}px`);
      });

      marquee.addEventListener('pointerup', finishDrag);
      marquee.addEventListener('pointercancel', finishDrag);
      marquee.addEventListener('click', (event) => {
        if (!hasDragged) return;

        event.preventDefault();
        event.stopPropagation();
        hasDragged = false;
      }, true);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-search"]) return;
  try {
    
  class YGSearchContent extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.$queryInput = this.querySelector('input[name="q"]');

      this.syncSearchPlaceholder = this.syncSearchPlaceholder.bind(this);
      this.syncSearchPlaceholder();

      document.addEventListener('shopify:section:load', this.syncSearchPlaceholder, {
        signal: this.abortController.signal,
      });

      if (!this.$queryInput) {
        return;
      }

      this.$queryInput.addEventListener('input', this.handleQueryChange.bind(this), {
        signal: this.abortController.signal,
      });
      this.handleQueryChange();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    handleQueryChange() {
      this.classList.toggle('has-query', this.$queryInput.value.trim().length > 0);
    }

    syncSearchPlaceholder() {
      document.querySelectorAll('[aria-controls="yg-search-overlay"] [data-yg-search-placeholder]').forEach(($label) => {
        $label.textContent = this.dataset.searchPlaceholder || '';
      });
    }
  }

  if (!window.customElements.get('yg-search-content')) {
    window.customElements.define('yg-search-content', YGSearchContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-story-timeline"] && !Shopify.designMode) return;
  try {
    
  class YGStoryTimeline extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.$swiper = this.querySelector('yg-swiper');
      this.$milestones = Array.from(this.querySelectorAll('[data-yg-story-milestone]'));
      this.$previousButton = this.querySelector('.yg-story-timeline__controller .swiper-button-prev');
      this.$nextButton = this.querySelector('.yg-story-timeline__controller .swiper-button-next');
      if (!this.$swiper || this.$milestones.length === 0) return;

      this.activeMilestoneIndex = 0;
      this.maxVisitedMilestoneIndex = 0;
      this.gestureDirection = null;
      this.updateMilestones = this.updateMilestones.bind(this);
      this.handleGestureStart = this.handleGestureStart.bind(this);
      this.handleGestureMove = this.handleGestureMove.bind(this);
      this.handleGestureEnd = this.handleGestureEnd.bind(this);
      this.handlePreviousClick = this.handlePreviousClick.bind(this);
      this.handlePreviousKeydown = this.handlePreviousKeydown.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);
      this.handleNextKeydown = this.handleNextKeydown.bind(this);

      if (this.$previousButton) {
        this.$previousButton.setAttribute('role', 'button');
        this.$previousButton.setAttribute('tabindex', '0');
        this.$previousButton.addEventListener('click', this.handlePreviousClick);
        this.$previousButton.addEventListener('keydown', this.handlePreviousKeydown);
      }

      if (this.$nextButton) {
        this.$nextButton.setAttribute('role', 'button');
        this.$nextButton.setAttribute('tabindex', '0');
        this.$nextButton.addEventListener('click', this.handleNextClick);
        this.$nextButton.addEventListener('keydown', this.handleNextKeydown);
      }

      this.isInitialized = true;
      this.bindSwiper();
    }

    disconnectedCallback() {
      window.cancelAnimationFrame(this.bindFrame);
      this.unbindSwiper();
      this.$previousButton?.removeEventListener('click', this.handlePreviousClick);
      this.$previousButton?.removeEventListener('keydown', this.handlePreviousKeydown);
      this.$nextButton?.removeEventListener('click', this.handleNextClick);
      this.$nextButton?.removeEventListener('keydown', this.handleNextKeydown);
      this.isInitialized = false;
    }

    bindSwiper() {
      if (!this.isConnected) return;

      if (!this.$swiper.swiper) {
        this.bindFrame = window.requestAnimationFrame(() => this.bindSwiper());
        return;
      }

      this.swiper = this.$swiper.swiper;
      this.swiper.on('touchStart', this.handleGestureStart);
      this.swiper.on('sliderMove', this.handleGestureMove);
      this.swiper.on('touchEnd', this.handleGestureEnd);
      this.swiper.on('resize', this.updateMilestones);
      this.updateMilestones();
    }

    unbindSwiper() {
      if (!this.swiper) return;

      this.swiper.off('touchStart', this.handleGestureStart);
      this.swiper.off('sliderMove', this.handleGestureMove);
      this.swiper.off('touchEnd', this.handleGestureEnd);
      this.swiper.off('resize', this.updateMilestones);
      this.swiper = null;
    }

    handleGestureStart() {
      this.gestureDirection = null;
    }

    handleGestureMove() {
      if (!this.swiper || Math.abs(this.swiper.touches.diff) < 20) return;

      this.gestureDirection = this.swiper.swipeDirection;
    }

    handleGestureEnd() {
      if (this.gestureDirection === 'next') {
        this.setActiveIndex(this.activeMilestoneIndex + 1);
      } else if (this.gestureDirection === 'prev') {
        this.setActiveIndex(this.activeMilestoneIndex - 1);
      }

      this.gestureDirection = null;
    }

    handlePreviousClick(event) {
      event.preventDefault();
      if (this.$previousButton?.classList.contains('is-disabled')) return;

      this.setActiveIndex(this.activeMilestoneIndex - 1);
    }

    handlePreviousKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      this.handlePreviousClick(event);
    }

    handleNextClick(event) {
      event.preventDefault();
      if (this.$nextButton?.classList.contains('is-disabled')) return;

      this.setActiveIndex(this.activeMilestoneIndex + 1);
    }

    handleNextKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      this.handleNextClick(event);
    }

    setActiveIndex(index) {
      const nextIndex = Math.max(0, Math.min(index, this.$milestones.length - 1));
      if (nextIndex === this.activeMilestoneIndex) return;

      this.activeMilestoneIndex = nextIndex;
      this.maxVisitedMilestoneIndex = Math.max(this.maxVisitedMilestoneIndex, nextIndex);
      this.swiper?.slideTo(nextIndex);
      this.updateMilestones();
    }

    updateMilestones() {
      const activeIndex = this.activeMilestoneIndex;

      this.$milestones.forEach(($milestone, index) => {
        $milestone.classList.toggle('is-complete', index < activeIndex);
        $milestone.classList.toggle('is-active', index === activeIndex);
        $milestone.classList.toggle('is-upcoming', index > this.maxVisitedMilestoneIndex);
        $milestone.setAttribute('aria-current', index === activeIndex ? 'step' : 'false');
      });

      this.updateNavigationButton(this.$previousButton, activeIndex === 0);
      this.updateNavigationButton(this.$nextButton, activeIndex === this.$milestones.length - 1);
    }

    updateNavigationButton($button, isDisabled) {
      if (!$button) return;

      $button.classList.toggle('is-disabled', isDisabled);
      $button.setAttribute('aria-disabled', String(isDisabled));
    }
  }

  if (!window.customElements.get('yg-story-timeline')) {
    window.customElements.define('yg-story-timeline', YGStoryTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList01 extends HTMLElement {
        constructor() {
            super();
            this.playbackMode = this.getAttribute('data-playback-mode');
            this.slideItems = this.querySelectorAll('.yg-slide-item');
            this.mobileQuery = window.matchMedia('(max-width: 699px)');
            this.boundSwipers = new WeakSet();
            this.syncAttemptCount = 0;
            this.syncRetryTimer = null;
            this.handleClickPlayback = this.handleClickPlayback.bind(this);
            this.handleMutedChange = this.handleMutedChange.bind(this);
            this.handleViewportChange = this.handleViewportChange.bind(this);
            this.syncCurrentSwiper = this.syncCurrentSwiper.bind(this);
            this.handleDocumentInteraction = this.handleDocumentInteraction.bind(this);
        }
        connectedCallback() {
            this.addEventListener('click', this.handleClickPlayback, true);
            this.addEventListener('YG:mutedChange', this.handleMutedChange);

            if (this.playbackMode === 'hover' && window.innerWidth > 1024) {
                this.initHoverPlayback();
            }

            this.mobileQuery.addEventListener('change', this.handleViewportChange);
            window.addEventListener('resize', this.syncCurrentSwiper, { passive: true });
            document.addEventListener('click', this.handleDocumentInteraction, true);
            document.addEventListener('touchend', this.handleDocumentInteraction, true);
            document.addEventListener('keyup', this.handleDocumentInteraction, true);
            this.handleViewportChange();
            window.setTimeout(this.handleViewportChange, 100);
            window.setTimeout(this.handleViewportChange, 300);
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClickPlayback, true);
            this.removeEventListener('YG:mutedChange', this.handleMutedChange);
            this.mobileQuery.removeEventListener('change', this.handleViewportChange);
            window.removeEventListener('resize', this.syncCurrentSwiper);
            document.removeEventListener('click', this.handleDocumentInteraction, true);
            document.removeEventListener('touchend', this.handleDocumentInteraction, true);
            document.removeEventListener('keyup', this.handleDocumentInteraction, true);
            window.clearTimeout(this.syncRetryTimer);
        }

        handleClickPlayback(event) {
            const target = event.target instanceof Element ? event.target : null;
            const volumeButton = target?.closest('.yg-video-list__volume-button');

            if (volumeButton && this.contains(volumeButton)) {
                event.preventDefault();
                event.stopPropagation();

                const currentVideo = volumeButton.closest('.yg-slide-item')?.querySelector('yg-video');
                if (!currentVideo?.toggleMuted) return;

                this.updateVolumeButton(volumeButton, currentVideo.toggleMuted());
                return;
            }

            const currentVideo = target ? target.closest('yg-video') : null;
            if (!currentVideo || !this.contains(currentVideo)) return;

            if (
                this.mobileQuery.matches &&
                currentVideo.classList.contains('is-playing') &&
                !target.closest('.yg-video-button')
            ) {
                event.preventDefault();
                event.stopPropagation();
                currentVideo.pauseVideo?.();
                return;
            }

            this.pauseOtherVideos(currentVideo);

            // The play button keeps its own click handler. Other clicks in the
            // video area should start playback too.
            if (this.playbackMode === 'click' && !target.closest('.yg-video-button')) {
                currentVideo.playVideo?.();
            }
        }

        handleMutedChange(event) {
            const currentVideo = event.target instanceof Element ? event.target.closest('yg-video') : null;
            const volumeButton = currentVideo?.closest('.yg-slide-item')?.querySelector('.yg-video-list__volume-button');
            if (!volumeButton) return;

            this.updateVolumeButton(volumeButton, Boolean(event.detail?.muted));
        }

        updateVolumeButton(button, muted) {
            button.classList.toggle('is-muted', muted);
            button.setAttribute('aria-pressed', String(!muted));
            button.setAttribute('aria-label', muted ? button.dataset.unmuteLabel : button.dataset.muteLabel);
        }

        pauseOtherVideos(currentVideo) {
            this.querySelectorAll('yg-video').forEach((videoEl) => {
                if (videoEl === currentVideo || typeof videoEl.pauseVideo !== 'function') return;
                videoEl.pauseVideo();
            });
        }

        initHoverPlayback() {
            this.slideItems.forEach(item => {
                const videoEl = item.querySelector('yg-video');
                if (!videoEl) return;

                item.addEventListener('mouseenter', () => {
                    if (videoEl.playVideo) {
                        this.pauseOtherVideos(videoEl);
                        videoEl.playVideo();
                    }
                });

                item.addEventListener('mouseleave', () => {
                    if (videoEl.pauseVideo) {
                        videoEl.pauseVideo();
                    }
                });
            });
        }

        handleViewportChange() {
            window.requestAnimationFrame(() => {
                this.bindSwiperEvents();
                this.syncCurrentSwiper();
            });
        }

        handleDocumentInteraction() {
            window.requestAnimationFrame(this.syncCurrentSwiper);
            window.setTimeout(this.syncCurrentSwiper, 80);
            window.setTimeout(this.syncCurrentSwiper, 240);
        }

        bindSwiperEvents() {
            this.querySelectorAll('yg-swiper').forEach((swiperElement) => {
                const swiper = swiperElement.swiper;

                if (!swiper || this.boundSwipers.has(swiper)) return;

                this.boundSwipers.add(swiper);
                swiper.on('slideChange transitionEnd resize breakpoint update', this.syncCurrentSwiper);
            });
        }

        getCurrentSwiperElement() {
            const selector = this.mobileQuery.matches ? '.yg-video-list-swiper-mobile' : '.yg-video-list-swiper-desktop';

            return this.querySelector(selector);
        }

        syncCurrentSwiper() {
            const swiperElement = this.getCurrentSwiperElement();
            const swiper = swiperElement?.swiper;

            if (!swiper || swiper.destroyed) {
                this.retrySync();
                return;
            }

            this.syncAttemptCount = 0;

            swiper.updateSize();
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            swiper.pagination?.update();
            this.syncNavigationState(swiperElement, swiper);
            window.requestAnimationFrame(() => this.syncNavigationState(swiperElement, swiper));
        }

        retrySync() {
            if (this.syncAttemptCount >= 20) return;

            this.syncAttemptCount += 1;
            window.clearTimeout(this.syncRetryTimer);
            this.syncRetryTimer = window.setTimeout(this.handleViewportChange, 50);
        }

        syncNavigationState(swiperElement, swiper) {
            const previousButton = swiperElement.querySelector('.swiper-button-prev');
            const nextButton = swiperElement.querySelector('.swiper-button-next');
            const isLocked = swiper.isLocked || swiper.snapGrid.length <= 1;

            this.setButtonState(previousButton, swiper.isBeginning || isLocked, isLocked);
            this.setButtonState(nextButton, swiper.isEnd || isLocked, isLocked);
        }

        setButtonState(button, isDisabled, isLocked) {
            if (!button) return;

            button.classList.toggle('swiper-button-disabled', isDisabled);
            button.classList.toggle('swiper-button-lock', isLocked);
            button.setAttribute('aria-disabled', String(isDisabled));
        }
    }
    if (!window.customElements.get('yg-video-list-01')) {
        window.customElements.define('yg-video-list-01', YGVideoList01);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
